export default {
    animation: Boolean | Object,
    autoBind: Boolean,
    autoClose: Boolean,
    autoWidth: Boolean,
    clearButton: Boolean,
    dataSource: Object | Array,
    dataTextField: String,
    dataValueField: String,
    delay: Number,
    enable: Boolean,
    enforceMinLength: Boolean,
    filter: String,
    fixedGroupTemplate: String | Function,
    footerTemplate: String | Function,
    groupTemplate: String | Function,
    height: Number,
    highlightFirst: Boolean,
    ignoreCase: Boolean,
    minLength: Number,
    maxSelectedItems: Number,
    noDataTemplate: String | Function,
    placeholder: String,
    popup: Object,
    headerTemplate: String | Function,
    itemTemplate: String | Function,
    tagTemplate: String | Function,
    tagMode: String,
    value: Array | Number,
    valuePrimitive: Boolean,
    virtual: Boolean | Object,

    // Events
    change: Function,
    close: Function,
    dataBound: Function,
    filtering: Function,
    open: Function,
    select: Function,
    deselect: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiSelect/MultiSelectProps.js